<template>
	<base-modal
		ref="$modal"
		:height="656"
		:width="600"
	>
		<app-avatar-editor @save="onSavePhoto"/>
	</base-modal>
</template>

<script setup lang="ts">
import { ref } from "vue";
import BaseModal from "@/components/common/modal/BaseModal.vue";
import AppAvatarEditor from "@/components/ui-kit/avatar-editor/AppAvatarEditor.vue";

const emit = defineEmits<{
	(e: 'save', value: string): void
}>()

const $modal = ref<typeof BaseModal | null>(null)

const onOpen = () => {
	$modal.value?.onOpen();
}

const onSavePhoto = (url: string): void => {
	emit('save', url)
	$modal.value?.onClose();
}

defineExpose({ onOpen })
</script>
